/**
 * Admin server functions for Nova usage reporting.
 *
 * Aliases: admin nova usage, nova cost report, token usage admin, weekly nova
 * numbers
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { permissionMiddleware } from "~/lib/permission-middleware";

export const adminNovaUsageQueryKeys = {
  summary: ["admin-nova-usage", "summary"] as const,
  weekly: ["admin-nova-usage", "weekly"] as const,
};

export const getAdminNovaUsageSummaryFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("nova-usage:read")])
  .handler(async () => {
    const { listNovaAdminUsageSummary } =
      await import("~/lib/server/nova/usage");
    return listNovaAdminUsageSummary();
  });

export const adminNovaUsageSummaryQueryOptions = queryOptions({
  queryKey: adminNovaUsageQueryKeys.summary,
  queryFn: () => getAdminNovaUsageSummaryFn(),
});

export const getAdminNovaWeeklyNumbersFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("nova-usage:read")])
  .handler(async () => {
    const [{ getDBWithInit }, { getNovaWeeklyNumbers }] = await Promise.all([
      import("~/lib/db"),
      import("~/lib/server/nova/weekly-numbers"),
    ]);
    return getNovaWeeklyNumbers(await getDBWithInit(), { now: new Date() });
  });

export const adminNovaWeeklyNumbersQueryOptions = queryOptions({
  queryKey: adminNovaUsageQueryKeys.weekly,
  queryFn: () => getAdminNovaWeeklyNumbersFn(),
});
